import { SimpleError } from '@common/errors';
import { Field } from '../classes/Field.js';
/** Declares an AutoEncoder property and its encoded representation. */
export function field(settings) {
    return (target /* future typeof Model */, key) => {
        if (!target.constructor.fields || !Object.hasOwn(target.constructor, 'fields')) {
            target.constructor.fields = target.constructor.fields?.slice(0) ?? [];
            target.constructor.fields.createdFor = target.constructor;
            target.constructor.cachedPatchType = undefined;
            // Reset caches
            // Override parent definitions
            target.constructor.__latestVersion = undefined;
            target.constructor.__latestFields = undefined;
            target.constructor.__fieldsForVersion = new Map();
            target.constructor.__cachedInstance = undefined;
        }
        const field = new Field();
        field.optional = settings.optional ?? false;
        field.nullable = settings.nullable ?? false;
        field.queryable = settings.queryable ?? false;
        field.decoder = settings.decoder;
        field.version = settings.version ?? 0;
        field.field = settings.field ?? key;
        field.upgrade = settings.upgrade;
        field.downgrade = settings.downgrade;
        field.upgradePatch = settings.upgradePatch;
        field.downgradePatch = settings.downgradePatch;
        field.defaultValue = settings.defaultValue;
        field.isDefaultValue = settings.isDefaultValue;
        field.patchDefaultValue = settings.patchDefaultValue;
        field.property = key;
        target.constructor.fields.push(field);
        // target.constructor.latestVersion = Math.max(target.constructor.latestVersion ?? 0, settings.version ?? 0);
        target.constructor.sortFields();
        const allFields = target.constructor.fields.filter(f => f.property === key);
        const propertyLatestVersion = Math.max(0, ...allFields.map(f => f.version));
        for (const f of allFields) {
            f.hasNewerField = (f.version) < propertyLatestVersion;
        }
        // Security check
        if (allFields.find(f => f !== field && !!f.defaultValue !== !!field.defaultValue)) {
            throw new SimpleError({
                code: 'missing_default_value',
                message: 'When you define defaultValue for at least one version of a property, you need to set if for each version. For property: ' + field.property,
                field: field.property,
            });
        }
    };
}
//# sourceMappingURL=Field.js.map